// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1xtW9","title":"AfterBackImages_title__1JMS4","images":"AfterBackImages_images__30Bxc"};